import { Component, Input } from '@angular/core';
import { CLINICIAN_MACRO_STATUS_META } from '../../../models/clinical-onboarding.model';

/**
 * DBEK-403: badge di macro-stato onboarding, riusabile ovunque serva mostrarlo -
 * scheda clinico nell'elenco membri (qui), colonna Tabella-1 della dashboard
 * (DBEK-409), banner del wizard clinico (gia' usato inline in DBEK-405, stessa
 * fonte dati CLINICIAN_MACRO_STATUS_META). Un solo punto da aggiornare se
 * icona/colore/etichetta di uno stato cambiano.
 */
@Component({
  selector: 'app-clinical-onboarding-status-badge',
  templateUrl: './clinical-onboarding-status-badge.component.html',
  styleUrls: ['./clinical-onboarding-status-badge.component.scss'],
  standalone: false,
})
export class ClinicalOnboardingStatusBadgeComponent {
  @Input() macroStatus: string;

  readonly macroStatusMeta = CLINICIAN_MACRO_STATUS_META;
}
